import { useEffect } from 'react';

//assets
import {
  setHubspotFormIntegration,
  DisclaimerText,
} from '@/vendor/HubspotFormIntegration';

import {
  Section,
  Wrapper,
  TitleContainer,
  FormContainer,
} from './HubspotForm.styles';

const HubspotForm = ({
  children = null,
  portalId,
  formId,
  target = 'integration-hubspot',
  disclaimer = false,
  variant,
}) => {
  useEffect(() => {
    setHubspotFormIntegration({
      portalId,
      formId,

      target: `#${target}`,
    });
  }, [formId, portalId, target]);

  return (
    <Section id="hubspot-form">
      <Wrapper variant={variant}>
        <TitleContainer className="Title">{children}</TitleContainer>
        <FormContainer>
          <div id={target} />
          {disclaimer && <DisclaimerText />}
        </FormContainer>
      </Wrapper>
    </Section>
  );
};

export default HubspotForm;
export { HubspotForm };
